import { delay } from "@kaggle/sdk";
import { AdhocClient } from "../services";

const adhoc: AdhocClient = {
  viewCompetitionsList: async (
    _category: string,
    _page: number,
    _search: string,
    _sortBy: string,
    _tab: string
  ) => {
    // Do nothing.
    return;
  },

  saveDraft: async ({ sequence }) => {
    await delay(300);
    return {
      wasSuccessful: true,
      result: { sequence: sequence + 1 },
    };
  },

  sendKeepAlive: (_url: string) => Promise.resolve(),
};

export default adhoc;
